<div class="row border_btm">
  
  <div class="col-md-6 filterby">
    {{ "plp.filterBy" | cxTranslate }}
    <div>
      <button
      #trigger
      class="btn btn-action btn-block dialog-trigger"
      (click)="launch()"
    >

  
    {{ "plp.filterBy" | cxTranslate }}
    </button>
    </div>
  </div>

  <div class="col-md-6 right">
    <div class="clear-all-link" (click)="clearAll()">{{ "plp.clearAll" | cxTranslate }}</div>
  </div>
  
</div>
	
<cx-active-facets (routerEmiited)='setRoutes($event)'></cx-active-facets>

<cx-facet-list
  *ngIf="isOpen$ | async"
  [isDialog]="hasTrigger"
  (closeList)="close()"
  [class.active]="isActive$ | async"
  [class.dialog]="hasTrigger"
></cx-facet-list>
